/* Collection is the default and free. Delivery is priced by distance from
   89129. Assembly is priced per item by how long that item takes to build,
   and is chosen per item.

   Build time is the honest basis for the fee: $40 to turn up plus $40 an
   hour. A mirror that clips onto a stand is a ten-minute job; a nine-drawer
   dresser is an hour and a half. Charging both the same was the thing that
   was wrong before.

   Distance comes from a table of ZIP centroids shipped with the theme, so
   there is no mapping API to pay for or rate-limit. */
(function () {
  var zones = null;

  function box() { return document.querySelector('[data-sg-local]'); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function dollars(n) { return '$' + Number(n).toFixed(2); }

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
  }

  function setAttributes(attrs) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    });
  }

  async function loadZones() {
    if (zones) return zones;
    const root = box();
    if (!root) return null;
    try { zones = await fetch(root.getAttribute('data-zones')).then(function (r) { return r.json(); }); }
    catch (e) { zones = null; }
    return zones;
  }

  /* nearest band at or above the build time, so nobody is undercharged for a
     job that runs long */
  function bandFor(mins, z) {
    const bands = z.assembly || [];
    for (var i = 0; i < bands.length; i++) {
      if (mins <= bands[i].mins) return bands[i];
    }
    return bands[bands.length - 1] || null;
  }

  function milesBetween(a, b) {
    const R = 3958.8;
    const rad = function (d) { return (d * Math.PI) / 180; };
    const dLat = rad(b[0] - a[0]);
    const dLon = rad(b[1] - a[1]);
    const s = Math.sin(dLat / 2) ** 2 +
      Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
  }

  function tierFor(mi, z) {
    for (var i = 0; i < z.tiers.length; i++) if (mi <= z.tiers[i].max) return z.tiers[i];
    return null;
  }

  function serviceVariantIds(z) {
    return z.tiers.map(function (t) { return String(t.id); })
      .concat((z.assembly || []).map(function (a) { return String(a.id); }));
  }

  async function addLine(id, qty) {
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }),
    });
  }

  async function removeVariants(ids) {
    const cart = await getCart();
    for (var i = 0; i < cart.items.length; i++) {
      const it = cart.items[i];
      if (ids.indexOf(String(it.variant_id)) !== -1) {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: 0 }),
        });
      }
    }
  }

  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location.reload(); return; }
    const res = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    ['.drawer__inner', '.cart-drawer__form', '.drawer__footer'].forEach(function (sel) {
      const from = doc.querySelector(sel);
      const to = drawer.querySelector(sel);
      if (from && to) to.innerHTML = from.innerHTML;
    });
  }

  function currentZip() {
    const root = box();
    const input = root && root.querySelector('[data-sg-local-zip]');
    return input ? (input.value || '').trim() : '';
  }

  /* price each item row from its own build time, and tick the ones already
     paid for so a redraw never loses the choice */
  async function paintItems() {
    const root = box();
    const z = await loadZones();
    if (!root || !z) return;
    const cart = await getCart();
    const counts = {};
    cart.items.forEach(function (i) {
      if ((z.assembly || []).some(function (a) { return String(a.id) === String(i.variant_id); })) {
        counts[String(i.variant_id)] = (counts[String(i.variant_id)] || 0) + i.quantity;
      }
    });

    root.querySelectorAll('[data-sg-item]').forEach(function (row) {
      const mins = Number(row.getAttribute('data-minutes')) || 45;
      const qty = Number(row.getAttribute('data-qty')) || 1;
      const band = bandFor(mins, z);
      if (!band) return;
      row.dataset.bandId = band.id;
      const priceEl = row.querySelector('[data-sg-item-price]');
      if (priceEl) priceEl.textContent = dollars(Number(band.price) * qty);
      const cb = row.querySelector('[data-sg-item-check]');
      if (cb && counts[String(band.id)]) cb.checked = true;
    });
  }

  async function check(silent) {
    const root = box();
    if (!root) return null;
    const z = await loadZones();
    if (!z) return null;

    const result = root.querySelector('[data-sg-local-result]');
    const offer = root.querySelector('[data-sg-local-offer]');
    const zip = currentZip();

    if (!/^\d{5}$/.test(zip)) {
      if (!silent) {
        result.hidden = false;
        result.textContent = 'Enter a five-digit ZIP code.';
        result.dataset.state = 'warn';
      }
      offer.hidden = true;
      showBooking();
      return null;
    }

    const here = z.zips[zip];
    const home = z.zips[z.home];
    result.hidden = false;

    if (!here) {
      result.textContent = 'That ZIP is outside the Las Vegas valley — this ships to you instead, free over $99.';
      result.dataset.state = 'no';
      offer.hidden = true;
      setAttributes({ 'Local ZIP': '' });
      showBooking();
      return null;
    }

    const mi = milesBetween(home, here);
    const tier = tierFor(mi, z);

    if (!tier) {
      result.textContent = Math.round(mi) + ' miles away — too far for us to deliver, but collection is welcome.';
      result.dataset.state = 'warn';
      offer.hidden = true;
      setAttributes({ 'Local ZIP': zip });
      showBooking();
      return null;
    }

    result.textContent = 'You are about ' + Math.round(mi) + ' miles from us.';
    result.dataset.state = 'yes';
    offer.hidden = false;

    const priceEl = root.querySelector('[data-sg-delivery-price]');
    if (priceEl) priceEl.textContent = dollars(tier.price);
    const noteEl = root.querySelector('[data-sg-delivery-note]');
    if (noteEl) noteEl.textContent = tier.label + ' from us.';

    root.dataset.tierId = tier.id;
    root.dataset.miles = String(Math.round(mi));
    setAttributes({ 'Local ZIP': zip });
    try { window.localStorage.setItem('sg-zip', zip); } catch (e) { /* private mode */ }

    await paintItems();
    /* Write the fulfilment details on every check, not only when a box is
       ticked. A reload used to leave the cart holding fees with nothing on the
       order saying where it was going or what to build. */
    await syncAttributes(z);
    showBooking();
    return tier;
  }

  /* One button. The existing checkout button is relabelled and re-pointed
     when there are fees to take; two buttons side by side only made people
     hesitate over which one was the real one. */
  function checkoutButtons() {
    return [].slice.call(document.querySelectorAll(
      'cart-drawer button[name="checkout"], .cart__checkout-button, .drawer__checkout-btn, form[action*="/cart"] button[name="checkout"]'
    ));
  }

  function setCheckoutMode(booking, feeText) {
    checkoutButtons().forEach(function (btn) {
      if (booking) {
        if (!btn.dataset.sgOriginal) btn.dataset.sgOriginal = btn.textContent.trim();
        btn.dataset.sgBooking = '1';
        btn.textContent = 'Book — pay ' + feeText + ' now';
      } else if (btn.dataset.sgBooking) {
        delete btn.dataset.sgBooking;
        if (btn.dataset.sgOriginal) btn.textContent = btn.dataset.sgOriginal;
      }
    });
  }

  async function showBooking() {
    const root = box();
    if (!root) { setCheckoutMode(false); return; }
    const panel = root.querySelector('[data-sg-local-book]');
    const offer = root.querySelector('[data-sg-local-offer]');
    if (!panel) return;

    const z = await loadZones();
    if (!z || !offer || offer.hidden) { panel.hidden = true; setCheckoutMode(false); return; }

    const serviceIds = serviceVariantIds(z);
    const cart = await getCart();
    const fees = cart.items.filter(function (i) { return serviceIds.indexOf(String(i.variant_id)) !== -1; });
    const items = cart.items.filter(function (i) { return serviceIds.indexOf(String(i.variant_id)) === -1; });

    if (!fees.length || !items.length) { panel.hidden = true; setCheckoutMode(false); return; }

    const feeTotal = fees.reduce(function (a, i) { return a + i.line_price; }, 0);
    const balance = items.reduce(function (a, i) { return a + i.line_price; }, 0);

    const f = panel.querySelector('[data-sg-book-fee]');
    if (f) f.textContent = money(feeTotal);
    const b = panel.querySelector('[data-sg-book-balance]');
    if (b) b.textContent = money(balance);
    panel.hidden = false;
    setCheckoutMode(true, money(feeTotal));
  }

  async function syncAttributes(z) {
    const root = box();
    const cart = await getCart();
    const tierIds = z.tiers.map(function (t) { return String(t.id); });
    const asmIds = (z.assembly || []).map(function (a) { return String(a.id); });
    const hasDelivery = cart.items.some(function (i) { return tierIds.indexOf(String(i.variant_id)) !== -1; });
    const built = [];
    root.querySelectorAll('[data-sg-item]').forEach(function (row) {
      const cb = row.querySelector('[data-sg-item-check]');
      if (cb && cb.checked) {
        const name = row.querySelector('.sg-local__item-name');
        built.push(name ? name.textContent.trim() : 'item');
      }
    });
    await setAttributes({
      'Local ZIP': currentZip(),
      Fulfilment: hasDelivery ? 'Delivery (' + (root.dataset.miles || '?') + ' mi)' : 'Collection',
      'Assemble for customer': built.length ? built.join('; ') : '',
    });
  }

  /* Getting it is either collection or delivery. Assembly is a separate
     question entirely: we can build it here and hand it over finished, so
     nothing about assembly should touch this. */
  async function setFulfilment(mode) {
    const root = box();
    const z = await loadZones();
    if (!z) return;
    const tierIds = z.tiers.map(function (t) { return String(t.id); });

    await removeVariants(tierIds);
    if (mode === 'delivery' && root.dataset.tierId) {
      await addLine(root.dataset.tierId, 1);
    }
    await syncAttributes(z);
    await refreshDrawer();
    restore();
  }

  async function toggleItem(row, on) {
    const root = box();
    const z = await loadZones();
    if (!z) return;
    const bandId = row.dataset.bandId;
    const qty = Number(row.getAttribute('data-qty')) || 1;
    if (!bandId) return;

    const cart = await getCart();
    const existing = cart.items.find(function (i) { return String(i.variant_id) === String(bandId); });
    const current = existing ? existing.quantity : 0;
    const next = on ? current + qty : Math.max(current - qty, 0);

    if (existing) {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: existing.key, quantity: next }),
      });
    } else if (on) {
      await addLine(bandId, qty);
    }

    await syncAttributes(z);
    await refreshDrawer();
    restore();
  }

  async function book() {
    const root = box();
    const z = await loadZones();
    if (!z) return;
    const btn = checkoutButtons()[0];
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'One moment…'; }

    try {
      const serviceIds = serviceVariantIds(z);
      const cart = await getCart();
      const goods = cart.items.filter(function (i) { return serviceIds.indexOf(String(i.variant_id)) === -1; });
      if (!goods.length) { if (btn) { btn.textContent = original; btn.disabled = false; } return; }

      const balance = goods.reduce(function (a, i) { return a + i.line_price; }, 0);
      const list = goods.map(function (i) {
        const v = i.variant_title && i.variant_title !== 'Default Title' ? ' (' + i.variant_title + ')' : '';
        return i.quantity + ' x ' + i.product_title + v;
      }).join('; ');

      /* Shopify's checkout cannot be edited without Plus, but line item
         properties are rendered under each line there. Stamping the balance
         onto the fee lines is the only way to make "there is still $250 to
         pay" unmissable on the checkout page itself, rather than only in the
         cart they have already left behind. */
      const collecting = !cart.items.some(function (i) {
        return z.tiers.some(function (t) { return String(t.id) === String(i.variant_id); });
      });
      const when = collecting ? 'when you collect' : 'on delivery';
      const props = {};
      props['Balance to pay ' + when] = money(balance);
      props['For'] = list;

      for (var s = 0; s < cart.items.length; s++) {
        const it = cart.items[s];
        if (serviceIds.indexOf(String(it.variant_id)) === -1) continue;
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props }),
        });
      }

      // written down before anything is removed, so nothing can be lost
      //
      // The balance key is named after how they are getting it, so someone
      // who switches between collection and delivery leaves the previous key
      // sitting in the cart. A real order arrived carrying three of them at
      // once — $300 handover, $250 on collection, $150 on delivery — which
      // is worse than no figure at all. Blank every variant we have ever
      // written, then set the one that is true now.
      const attrs = {
        'Local ZIP': currentZip(),
        'Furniture to hand over': list,
        'Balance to pay on delivery': '',
        'Balance to pay when you collect': '',
        'Balance due on handover': '',
        Assembly: '',
      };
      attrs['Balance to pay ' + when] = money(balance);
      await setAttributes(attrs);
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: 'LOCAL BOOKING — ' + list + '. Balance due on handover: ' + money(balance) + '.',
        }),
      });

      try {
        window.localStorage.setItem('sg-booking-cart', JSON.stringify(goods.map(function (i) {
          return { id: i.variant_id, quantity: i.quantity };
        })));
      } catch (e) { /* private mode */ }

      for (var n = 0; n < goods.length; n++) {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: goods[n].key, quantity: 0 }),
        });
      }

      window.location.href = window.Shopify.routes.root + 'checkout';
    } catch (e) {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  }

  async function restoreBooking() {
    const root = box();
    if (!root) return;
    let saved = null;
    try { saved = JSON.parse(window.localStorage.getItem('sg-booking-cart') || 'null'); } catch (e) { return; }
    if (!saved || !saved.length) return;

    const z = await loadZones();
    if (!z) return;
    const serviceIds = serviceVariantIds(z);
    const cart = await getCart();
    const onlyFees = cart.items.length > 0 &&
      cart.items.every(function (i) { return serviceIds.indexOf(String(i.variant_id)) !== -1; });
    if (!onlyFees) { try { window.localStorage.removeItem('sg-booking-cart'); } catch (e) {} return; }

    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: saved.map(function (s) { return { id: Number(s.id), quantity: s.quantity }; }) }),
    });
    try { window.localStorage.removeItem('sg-booking-cart'); } catch (e) {}
    await refreshDrawer();
    restore();
  }

  function setOpen(open) {
    const root = box();
    if (!root) return;
    const panel = root.querySelector('[data-sg-local-panel]');
    const toggle = root.querySelector('[data-sg-local-toggle]');
    if (!panel || !toggle) return;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    try { window.localStorage.setItem('sg-local-open', open ? '1' : '0'); } catch (e) { /* ignore */ }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    const t = e.target.closest('[data-sg-local-toggle]');
    if (t) { e.preventDefault(); setOpen(t.getAttribute('aria-expanded') !== 'true'); return; }

    if (e.target.closest('[data-sg-local-check]')) { e.preventDefault(); check(false); return; }

    const co = e.target.closest('button[name="checkout"], .cart__checkout-button, .drawer__checkout-btn');
    if (co && co.dataset.sgBooking) { e.preventDefault(); e.stopPropagation(); book(); }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-sg-local-zip]')) {
      e.preventDefault();
      check(false);
    }
  });

  document.addEventListener('change', async function (e) {
    const fulfil = e.target.closest && e.target.closest('[data-sg-fulfil]');
    if (fulfil) {
      const group = document.querySelectorAll('[data-sg-fulfil]');
      group.forEach(function (r) { r.disabled = true; });
      try { await setFulfilment(fulfil.value); }
      finally { group.forEach(function (r) { r.disabled = false; }); }
      return;
    }
    const item = e.target.closest && e.target.closest('[data-sg-item-check]');
    if (item) {
      item.disabled = true;
      try { await toggleItem(item.closest('[data-sg-item]'), item.checked); } finally { item.disabled = false; }
    }
  });

  function restore() {
    const root = box();
    if (!root) return;
    let zip = null;
    let wasOpen = null;
    try {
      zip = window.localStorage.getItem('sg-zip');
      wasOpen = window.localStorage.getItem('sg-local-open');
    } catch (e) { /* ignore */ }

    const input = root.querySelector('[data-sg-local-zip]');
    if (zip && input && !input.value) input.value = zip;

    setOpen(wasOpen === '1' || root.getAttribute('data-delivery-in') === 'true' || !!zip);
    check(true);
    restoreBooking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
  document.addEventListener('shopify:section:load', restore);
})();
